document.addEventListener('DOMContentLoaded', function() {
       // Deshabilitar arrastre de imágenes
       document.querySelectorAll('img').forEach(function(img) {
         img.ondragstart = function() {
           return false;
         };
       });

       // Deshabilitar selección de texto
       document.body.onselectstart = function() {
         return false;
       };
     });
 document.addEventListener('DOMContentLoaded', function() {
       // Deshabilitar el clic derecho
       document.addEventListener('contextmenu', function(event) {
         event.preventDefault();
       });
     });